import { AuditItem, AxiosArgs, GetAuditV2Query, GetAuditV2RootPath, ThenArgs } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody, encodeQueryParams } from 'src/api/client';

type RequestAssistance = (parameters: {
  text: string;
  url: string;
  workspaceId: string;
  source: string;
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse>>>;

export const requestAssistance: RequestAssistance = (parameters) => {
  const path = `/api/public/api/request-assistance`;

  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(parameters),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
// ------------------------------------------------------------

type GetAuditV2 = (
  rootPath: GetAuditV2RootPath,
  query: GetAuditV2Query,
) => Promise<{
  total: number;
  items: AuditItem[];
}>;

export const getAuditV2: GetAuditV2 = (rootPath, query) => {
  const path = `/api/public/api/audit/${rootPath}${encodeQueryParams({ ...query })}`;

  return axios({
    method: 'GET',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
// ------------------------------------------------------------

type AuditEvent = (data: {
  action: 'ExportCsv';
  resource: 'assessment' | 'incident' | 'control' | 'scenario';
  assessment_id?: string;
  scenario_id?: string;
  control_id?: string[];
  incident_id?: string[];
}) => Promise<AxiosArgs<ThenArgs<AxiosResponse<unknown>>>>;

export const auditEvent: AuditEvent = (data) => {
  const path = `/api/public/api/audit/event`;

  return axios({
    method: 'POST',
    url: path,
    data: encodeBody(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
// ------------------------------------------------------------

type InvokeAuth0CleanUp = () => Promise<void>;

export const callCleanUp: InvokeAuth0CleanUp = () => {
  const path = `/api/public/api/access-check-clean-up`;
  return axios({
    method: 'POST',
    url: path,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
};
